'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import PaymentType from './components/PaymentType.vue';

var _class = function _class() {
    _classCallCheck(this, _class);

    // Register component globaly
    Vue.component('payment-type', PaymentType);
};

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/checkout/components/payment-type/index.js
// module id = null
// module chunks = 